export type ParsedConvoyMarkerId =
  | { kind: 'cluster'; shipmentId: number; clusterId: string }
  | { kind: 'device'; shipmentId: number; deviceId: number };

export function convoyClusterMarkerId(
  shipmentId: number,
  clusterId: string,
): string {
  return `convoy-${shipmentId}-${clusterId}`;
}

export function convoyDeviceMarkerId(
  shipmentId: number,
  deviceId: number,
): string {
  return `convoy-${shipmentId}-dev-${deviceId}`;
}

/** Cluster ids are sorted member device ids joined by `-` (see cluster-by-proximity). */
export function deviceIdsFromConvoyClusterId(clusterId: string): number[] {
  const ids: number[] = [];
  for (const part of clusterId.split('-')) {
    if (!/^\d+$/.test(part)) continue;
    const id = Number(part);
    if (id > 0) ids.push(id);
  }
  return ids;
}

export function parseConvoyMarkerId(
  markerId: string,
): ParsedConvoyMarkerId | null {
  const device = /^convoy-(\d+)-dev-(\d+)$/.exec(markerId);
  if (device) {
    const shipmentId = Number(device[1]);
    const deviceId = Number(device[2]);
    if (shipmentId > 0 && deviceId > 0) {
      return { kind: 'device', shipmentId, deviceId };
    }
    return null;
  }
  const cluster = /^convoy-(\d+)-(.+)$/.exec(markerId);
  if (!cluster) return null;
  const shipmentId = Number(cluster[1]);
  const clusterId = cluster[2] ?? '';
  if (shipmentId > 0 && clusterId && !clusterId.startsWith('dev-')) {
    return { kind: 'cluster', shipmentId, clusterId };
  }
  return null;
}
